import axios, {AxiosResponse} from "axios";
import get from "lodash-es/get";
import config from "app/api/axiosConfig";
import { IChatNotification } from 'app/api/types/ChatNotification';

export default (token: string) =>
	axios.get(`${process.env.REACT_APP_CHAT_HOST}/Api/Notifications`, config(token))
		.then((response: AxiosResponse) => {
			const notifications: IChatNotification[] = get(response, "data", {});
			return Promise.resolve(notifications)
		})
